<script setup lang="ts">
const props = defineProps<{
  code: string
  language?: string
  /** file name */
  blockName?: string
}>()

const {data: highlightedHtml} = await useAsyncData(
  `shiki-${props.language ?? 'text'}-${props.code}`,
  async () => {
    const {codeToHtml} = await import('shiki')
    return codeToHtml(props.code ?? '', {
      lang: props.language ?? 'text',
      theme: 'github-light',
    })
  },
  {
    server: true,
    watch: [() => props.code, () => props.language, () => props.blockName],
  }
)

const ext = props.blockName?.split('.').pop()

const extToIcon = {
  ts: 'file-icons:typescript',
  tsx: 'file-icons:tsx',
  js: 'file-icons:typescript',
  jsx: 'file-icons:jsx',
  cs: 'file-icons:c-script',
  json: 'file-icons:json-1',
  jsonc: 'file-icons:json-1',
  yml: 'file-icons:yaml',
  yaml: 'file-icons:yaml',
  env: 'file-icons:dotenv',
  go: 'file-icons:go',
  vue: 'file-icons:vue',
}
</script>

<template>
  <div class="not-prose my-6 overflow-hidden rounded-lg text-sm bordershadow-gray">
    <div
      v-if="blockName && ext"
      class="flex h-10 items-center gap-x-2 border-b bg-gray-100 px-6 text-gray-800 bordershadow-gray"
    >
      <Icon :name="extToIcon[ext as keyof typeof extToIcon] || 'file-icons:manpage'" :size="12" />
      <span class="font-normal">
        {{ blockName }}
      </span>
    </div>
    <div class="font-mono" v-html="highlightedHtml"></div>
  </div>
</template>

<style>
.not-prose pre {
  margin: 0;
  padding: 1.25rem 1.5rem;
  overflow-x: auto;
  line-height: 1.7;
}
</style>
